<template>
    <b-modal ref="mdlProgrammaRiabilitativo" :title="titoloModale" size="xl" centered scrollable no-close-on-backdrop no-close-on-esc :hide-header-close="isSaving" @shown="onShown" @hidden="onHidden">
        <fieldset :disabled="isSaving">
            <rsa-scheda-programma-riabilitativo-edit-component v-if="isOpen" ref="cmpProgrammaRiabilitativoEdit" :isReadOnly="isModalView" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-scheda-programma-riabilitativo-edit-component>
        </fieldset>
        <template #modal-footer>
            <b-button v-if="isModalView" variant="outline-primary" @click="onClickOk">Ok</b-button>
            <template v-else>
                <b-button variant="outline-danger" :disabled="isSaving" @click="onClickUndo">Annulla</b-button>
                <b-button variant="outline-success" :disabled="isSaving || !jsonDataReady" @click="onSalvaProgrammaRiabilitativo">Salva</b-button>
            </template>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaSchedaProgrammaRiabilitativoEditComponent from "./RsaSchedaProgrammaRiabilitativoEditComponent.vue";

export default {
    name: "RsaPazienteSchedaProgrammaRiabilitativoModalEdit",
    components: { ModalError, RsaSchedaProgrammaRiabilitativoEditComponent },
    data() {
        return {
            idAccettazione: null,
            idRisorsa: null,
            pathResource: "/rsaschedaprogrammariabilitativo",
            isModalView: false,
            isOpen: false,
            isSaving: false,
            jsonDataReady: false,
            jsonData: {},
        };
    },
    computed: {
        titoloModale() {
            if (this.isModalView) return "Visualizzazione Programma Riabilitativo";
            return this.idRisorsa ? "Modifica Programma Riabilitativo" : "Nuovo Programma Riabilitativo";
        },
    },
    methods: {
        show(idAccettazione) {
            this.openModal(idAccettazione, null, false);
        },
        visualizzaScheda(item) {
            this.openModal(this.idAccettazione, item.id, true);
        },
        modificaScheda(item) {
            this.openModal(this.idAccettazione, item.id, false);
        },
        openModal(idAccettazione, idRisorsa, isModalView) {
            this.idAccettazione = idAccettazione;
            this.idRisorsa = idRisorsa;
            this.isModalView = isModalView;
            this.jsonData = {};
            this.jsonDataReady = false;
            this.isOpen = true;
            this.$refs.mdlProgrammaRiabilitativo.show();
        },
        onShown() {
            this.$refs.cmpProgrammaRiabilitativoEdit.init(this.idAccettazione, this.idRisorsa);
        },
        onUpdateJsonData(data) {
            this.jsonData = data;
            this.jsonDataReady = this.$refs.cmpProgrammaRiabilitativoEdit.jsonDataReady;
        },
        onBeforeLoadData() {
            this.$emit("beforeLoadData");
        },
        onAfterLoadData() {
            let component = this.$refs.cmpProgrammaRiabilitativoEdit;
            this.jsonDataReady = component.jsonDataReady;
            if (this.jsonDataReady) this.jsonData = component.jsonData;
            this.$emit("afterLoadData");
        },
        onSalvaProgrammaRiabilitativo() {
            if (this.isSaving || !this.jsonDataReady) return;
            let me = this;
            me.isSaving = true;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultSaveResponse, me.resultSaveError);
        },
        resultSaveResponse(response) {
            let me = this;
            if (response.data.esito === false) {
                me.resultSaveError(new Error(response.data.messaggio || "Errore nel salvataggio della scheda"));
                return;
            }
            me.isSaving = false;
            me.$emit("afterLoadData");
            me.$emit("afterSave");
            me.$refs.mdlProgrammaRiabilitativo.hide();
        },
        resultSaveError(error) {
            let me = this;
            me.isSaving = false;
            me.$emit("afterLoadData");
            let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : error.message;
            me.$refs.cmpModalError.show(messaggio || "Errore nel salvataggio della scheda");
        },
        onClickUndo() {
            this.$refs.mdlProgrammaRiabilitativo.hide();
        },
        onClickOk() {
            this.$refs.mdlProgrammaRiabilitativo.hide();
        },
        onHidden() {
            this.isOpen = false;
            this.isModalView = false;
            this.isSaving = false;
            this.jsonDataReady = false;
            this.jsonData = {};
            this.idRisorsa = null;
        },
    },
};
</script>
